import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import app from 'flarum/common/app';

export default class PointsLeaderboardPage extends Page {
  parseQueryParams() {
    // 使用 m.route.param() 获取查询参数：Flarum 使用 hash 路由，查询字符串在 hash 中，
    // window.location.search 会为空，导致 period/tab 无法正确解析
    const period = m.route.param('period');
    let tab = m.route.param('tab');
    const page = m.route.param('page');
    // tab=moderators 在 UI 上对应 personal（版主）
    if (tab === 'moderators') tab = 'personal';
    // 默认显示版主排行，如果 tab 参数无效也使用默认值
    const validTabs = ['personal', 'users', 'group'];
    const defaultTab = validTabs.includes(tab) ? tab : 'personal';
    return {
      period: period || 'alltime',
      tab: defaultTab,
      page: parseInt(page || '1')
    };
  }

  oninit(vnode) {
    super.oninit(vnode);
    
    const q = this.parseQueryParams();
    this.period = q.period;
    this.activeTab = q.tab;
    this.currentPage = q.page;
    
    this.boardList = [];
    this.meta = {};
    this.loading = true;
    this.loadingMore = false;
    this.hasMore = false;
    this.periodOpen = false;
    this.tabOpen = false;
    
    this.loadResults();
  }

  onupdate() {
    const q = this.parseQueryParams();
    const newPeriod = q.period;
    const newTab = q.tab;
    
    if (this.period !== newPeriod || this.activeTab !== newTab) {
      this.period = newPeriod;
      this.activeTab = newTab;
      
      // 每次参数变化都清空数据并重新加载
      this.boardList = [];
      this.loading = true;
      this.currentPage = 1;
      this.hasMore = false;
      
      this.loadResults();
    }
  }

  buildQuery(params) {
    const q = new URLSearchParams();
    if (params.period) q.set('period', params.period);
    if (params.tab) q.set('tab', params.tab);
    if (params.page && params.page > 1) q.set('page', params.page);
    const query = q.toString();
    return query ? '?' + query : '';
  }

  view() {
    return (
      <div className="PointsLeaderboardPage">
        <div className="container">
          {this.renderHeader()}
          {this.renderTabs()}
          {this.renderContent()}
        </div>
      </div>
    );
  }

  renderHeader() {
    const periodLabel = () => {
      switch (this.period) {
        // case 'day': return app.translator.trans('tf-points.forum.leaderboard-period-day') || 'Day';
        case 'week': return app.translator.trans('tf-points.forum.leaderboard-period-week');
        case 'month': return app.translator.trans('tf-points.forum.leaderboard-period-month');
        // case 'quarter': return app.translator.trans('tf-points.forum.leaderboard-period-quarter') || 'Quarter';
        case 'year': return app.translator.trans('tf-points.forum.leaderboard-period-year');
        default: return app.translator.trans('tf-points.forum.leaderboard-period-all-time');
      }
    };

    const tabLabel = () => {
      switch (this.activeTab) {
        case 'personal': return app.translator.trans('tf-points.forum.leaderboard-tab-moderators');
        case 'users': return app.translator.trans('tf-points.forum.leaderboard-tab-users');
        case 'group': return app.translator.trans('tf-points.forum.leaderboard-tab-groups');
        default: return app.translator.trans('tf-points.forum.leaderboard-tab-moderators');
      }
    };

    return (
      <div className="PointsLeaderboardPage-header">
        <h1 className="PointsLeaderboardPage-title">
          {app.translator.trans('tf-points.forum.leaderboard-page-title')}
        </h1>
        <div className="PointsLeaderboardPage-header-filters">
          <div className="PointsLeaderboardPage-periodDropdown">
            <button className="Button Button--link" onclick={() => { this.periodOpen = !this.periodOpen; this.tabOpen = false; m.redraw(); }}>
              {periodLabel()} <i className="fa-light fa-chevron-down"></i>
            </button>
            {this.periodOpen && (
              <ul className="PointsLeaderboardPage-menu">
                {['alltime', 'week', 'month', 'year'].map(key => (
                  <li>
                    <button className={`Button Button--link ${this.period === key ? 'is-active' : ''}`}
                      onclick={() => {
                        this.period = key;
                        this.periodOpen = false;
                        this.currentPage = 1;
                        this.boardList = [];
                        this.loading = true;
                        this.hasMore = false;
                        m.route.set(app.route('pointsLeaderboard') + this.buildQuery({ period: key, tab: this.activeTab }));
                        this.loadResults();
                      }}>
                      {key === 'alltime' ? app.translator.trans('tf-points.forum.leaderboard-period-all-time') :
                       key === 'week' ? app.translator.trans('tf-points.forum.leaderboard-period-week') :
                       key === 'month' ? app.translator.trans('tf-points.forum.leaderboard-period-month') :
                       app.translator.trans('tf-points.forum.leaderboard-period-year')}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="PointsLeaderboardPage-tabDropdown">
            <button className="Button Button--link" onclick={() => { this.tabOpen = !this.tabOpen; this.periodOpen = false; m.redraw(); }}>
              {tabLabel()} <i className="fa-light fa-chevron-down"></i>
            </button>
            {this.tabOpen && (
              <ul className="PointsLeaderboardPage-menu">
                <li>
                  <button className={`Button Button--link ${this.activeTab === 'personal' ? 'is-active' : ''}`}
                    onclick={() => {
                      if (this.activeTab !== 'personal') {
                        this.activeTab = 'personal';
                        this.tabOpen = false;
                        this.currentPage = 1;
                        this.boardList = [];
                        this.loading = true;
                        this.hasMore = false;
                        m.route.set(app.route('pointsLeaderboard') + this.buildQuery({ period: this.period, tab: 'personal' }));
                        this.loadResults();
                      }
                    }}>
                    {app.translator.trans('tf-points.forum.leaderboard-tab-moderators')}
                  </button>
                </li>
                <li>
                  <button className={`Button Button--link ${this.activeTab === 'users' ? 'is-active' : ''}`}
                    onclick={() => {
                      if (this.activeTab !== 'users') {
                        this.activeTab = 'users';
                        this.tabOpen = false;
                        this.currentPage = 1;
                        this.boardList = [];
                        this.loading = true;
                        this.hasMore = false;
                        m.route.set(app.route('pointsLeaderboard') + this.buildQuery({ period: this.period, tab: 'users' }));
                        this.loadResults();
                      }
                    }}>
                    {app.translator.trans('tf-points.forum.leaderboard-tab-users')}
                  </button>
                </li>
                <li>
                  <button className={`Button Button--link ${this.activeTab === 'group' ? 'is-active' : ''}`}
                    onclick={() => {
                      if (this.activeTab !== 'group') {
                        this.activeTab = 'group';
                        this.tabOpen = false;
                        this.currentPage = 1;
                        this.boardList = [];
                        this.loading = true;
                        this.hasMore = false;
                        m.route.set(app.route('pointsLeaderboard') + this.buildQuery({ period: this.period, tab: 'group' }));
                        this.loadGroupResults();
                      }
                    }}>
                    {app.translator.trans('tf-points.forum.leaderboard-tab-groups')}
                  </button>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderTabs() {
    // Tabs are now in header as dropdown, so this method is no longer needed
    return null;
  }

  renderContent() {
    if (this.loading && this.boardList.length === 0) {
      return (
        <div className="PointsLeaderboardPage-loading">
          <LoadingIndicator />
        </div>
      );
    }

    if (this.activeTab === 'group') {
      return this.renderGroupList();
    }

    // personal（版主）和 users（普通用户）标签都使用 renderPersonalList 显示
    return this.renderPersonalList();
  }

  renderPersonalList() {
    if (this.boardList.length === 0 && !this.loading) {
      return (
        <div className="PointsLeaderboardPage-empty">
          {app.translator.trans('tf-points.forum.leaderboard-empty')}
        </div>
      );
    }

    const renderAvatar = (item, size = 'normal') => {
      const url = item?.attributes?.avatarUrl || item?.attributes?.cover_image;
      const name = item?.attributes?.displayName || item?.attributes?.username || '';
      const initial = (name || '?').toString().charAt(0).toUpperCase();
      const avatarClass = size === 'large' ? 'LeaderboardPage-avatar-img-large' : 'LeaderboardPage-avatar-img';
      const fallbackClass = size === 'large' ? 'LeaderboardPage-avatar-fallback-large' : 'LeaderboardPage-avatar-fallback';
      
      if (url) {
        return <img className={avatarClass} src={url} alt={name} />;
      }
      return <div className={fallbackClass}>{initial}</div>;
    };

    const renderRankBadge = (rank) => {
      let badgeClass = 'LeaderboardPage-rank-badge';
      let badgeColor = '#999999'; // 默认灰色
      
      if (rank === 1) {
        badgeColor = '#ffd700'; // 金色
      } else if (rank === 2) {
        badgeColor = '#4a90e2'; // 蓝色
      } else if (rank === 3) {
        badgeColor = '#e53935'; // 红色
      }
      
      return (
        <div className={badgeClass} style={`background-color: ${badgeColor};`}>
          {rank}
        </div>
      );
    };

    // 分离前3名和其余排名
    const topThree = [];
    const restList = [];
    
    this.boardList.forEach((item, idx) => {
      const rank = idx + 1;
      if (rank <= 3 && this.boardList.length > 0) {
        topThree.push({ item, rank });
      } else {
        restList.push({ item, rank });
      }
    });

    return (
      <div className="PointsLeaderboardPage-list">
        {/* 前3名横向展示 */}
        {topThree.length > 0 && (
          <div className="PointsLeaderboardPage-top-three">
            {topThree.map(({ item, rank }) => {
              const name = item?.attributes?.displayName || item?.attributes?.username || 'Unknown';
              const pts = item?.attributes?.remote_points !== null ? item?.attributes?.remote_points : 0;
              return (
                <div key={item.id || rank} className="PointsLeaderboardPage-top-item">
                  <div className="PointsLeaderboardPage-top-avatar-wrapper">
                    {renderAvatar(item, 'large')}
                    {renderRankBadge(rank)}
                  </div>
                  <div className="PointsLeaderboardPage-top-name">{name}</div>
                  <div className="PointsLeaderboardPage-top-points">{pts} {app.translator.trans('tf-points.forum.leaderboard-points-text')}</div>
                </div>
              );
            })}
          </div>
        )}

        {/* 排名4及以后的列表 */}
        {restList.length > 0 && (
          <div className="PointsLeaderboardPage-rest-list">
            
            <ol className="PointsLeaderboardPage-items">
              {restList.map(({ item, rank }) => {
                const name = item?.attributes?.displayName || item?.attributes?.username || 'Unknown';
                const pts = item?.attributes?.period_points !== undefined ? item?.attributes?.period_points : (item?.attributes?.points || 0);
                
                return (
                  <li key={item.id || rank} className="PointsLeaderboardPage-item">
                    <div className="PointsLeaderboardPage-item-rank">{rank}</div>
                    <div className="PointsLeaderboardPage-item-avatar">{renderAvatar(item)}</div>
                    <div className="LeaderboardPage-name">{name}</div>
                    <div className="PointsLeaderboardPage-item-points">{pts} {app.translator.trans('tf-points.forum.leaderboard-points-text')}</div>
                  </li>
                );
              })}
            </ol>
          </div>
        )}

        {/* 如果第一页没有前3名，显示完整列表 */}
        {topThree.length === 0 && this.boardList.length > 0 && (
          <div className="PointsLeaderboardPage-rest-list">
            
            <ol className="PointsLeaderboardPage-items">
              {this.boardList.map((item, idx) => {
                const rank = idx + 1;
                const name = item?.attributes?.displayName || item?.attributes?.username || 'Unknown';
                const pts = item?.attributes?.period_points !== undefined ? item?.attributes?.period_points : (item?.attributes?.points || 0);
                
                return (
                  <li key={item.id || rank} className="PointsLeaderboardPage-item">
                    <div className="PointsLeaderboardPage-item-rank">{rank}</div>
                    <div className="PointsLeaderboardPage-item-avatar">{renderAvatar(item)}</div>
                    <div className="LeaderboardPage-name">{name}</div>
                    <div className="PointsLeaderboardPage-item-points">{pts} {app.translator.trans('tf-points.forum.leaderboard-points-text')}</div>
                  </li>
                );
              })}
            </ol>
          </div>
        )}

        {this.renderPagination()}
      </div>
    );
  }

  renderGroupList() {
    if (this.boardList.length === 0 && !this.loading) {
      return (
        <div className="PointsLeaderboardPage-empty">
          {app.translator.trans('tf-points.forum.leaderboard-empty')}
        </div>
      );
    }

    const renderAvatar = (item, size = 'normal') => {
      const url = item?.attributes?.cover_image;
      const name = item?.attributes?.name || 'Group';
      const initial = (name || '?').toString().charAt(0).toUpperCase();
      const avatarClass = size === 'large' ? 'LeaderboardPage-avatar-img-large' : 'LeaderboardPage-avatar-img';
      const fallbackClass = size === 'large' ? 'LeaderboardPage-avatar-fallback-large' : 'LeaderboardPage-avatar-fallback';
      
      if (url) {
        return <img className={avatarClass} src={url} alt={name} />;
      }
      return <div className={fallbackClass}>{initial}</div>;
    };

    const renderRankBadge = (rank) => {
      let badgeClass = 'LeaderboardPage-rank-badge';
      let badgeColor = '#999999'; // 默认灰色
      
      if (rank === 1) {
        badgeColor = '#ffd700'; // 金色
      } else if (rank === 2) {
        badgeColor = '#4a90e2'; // 蓝色
      } else if (rank === 3) {
        badgeColor = '#e53935'; // 红色
      }
      
      return (
        <div className={badgeClass} style={`background-color: ${badgeColor};`}>
          {rank}
        </div>
      );
    };

    // 分离前3名和其余排名
    const topThree = [];
    const restList = [];
    
    this.boardList.forEach((item, idx) => {
      const rank = idx + 1;
      if (rank <= 3 && this.boardList.length > 0) {
        topThree.push({ item, rank });
      } else {
        restList.push({ item, rank });
      }
    });

    return (
      <div className="PointsLeaderboardPage-list">
        {/* 前3名横向展示 */}
        {topThree.length > 0 && (
          <div className="PointsLeaderboardPage-top-three">
            {topThree.map(({ item, rank }) => {
              const name = item?.attributes?.name || 'Group';
              const heat = item?.attributes?.heat_total || 0;
              
              return (
                <div key={item.id || rank} className="PointsLeaderboardPage-top-item">
                  <div className="PointsLeaderboardPage-top-avatar-wrapper">
                    {renderAvatar(item, 'large')}
                    {renderRankBadge(rank)}
                  </div>
                  <div className="PointsLeaderboardPage-top-name">{name}</div>
                  <div className="PointsLeaderboardPage-top-points">{heat} pts</div>
                </div>
              );
            })}
          </div>
        )}

        {/* 排名4及以后的列表 */}
        {restList.length > 0 && (
          <div className="PointsLeaderboardPage-rest-list">
            
            <ol className="PointsLeaderboardPage-items">
              {restList.map(({ item, rank }) => {
                const name = item?.attributes?.name || 'Group';
                const heat = item?.attributes?.heat_total || 0;
                
                return (
                  <li key={item.id || rank} className="PointsLeaderboardPage-item">
                    <div className="PointsLeaderboardPage-item-rank">{rank}</div>
                    <div className="PointsLeaderboardPage-item-avatar">{renderAvatar(item)}</div>
                    <div className="LeaderboardPage-name">{name}</div>
                    <div className="PointsLeaderboardPage-item-points">{heat} pts</div>
                  </li>
                );
              })}
            </ol>
          </div>
        )}

        {/* 如果第一页没有前3名，显示完整列表 */}
        {topThree.length === 0 && this.boardList.length > 0 && (
          <div className="PointsLeaderboardPage-rest-list">
           
            <ol className="PointsLeaderboardPage-items">
              {this.boardList.map((item, idx) => {
                const name = item?.attributes?.name || 'Group';
                const heat = item?.attributes?.heat_total || 0;
                const rank = idx + 1;
                
                return (
                  <li key={item.id || rank} className="PointsLeaderboardPage-item">
                    <div className="PointsLeaderboardPage-item-rank">{rank}</div>
                    <div className="PointsLeaderboardPage-item-avatar">{renderAvatar(item)}</div>
                    <div className="LeaderboardPage-name">{name}</div>
                    <div className="PointsLeaderboardPage-item-points">{heat} pts</div>
                  </li>
                );
              })}
            </ol>
          </div>
        )}

        {this.renderPagination()}
      </div>
    );
  }


  renderPagination() {
    // 只有在有更多数据或正在加载更多时才显示按钮
    // 并且列表不为空
    if ((!this.hasMore && !this.loadingMore) || this.boardList.length === 0) {
      return null;
    }

    return (
      <div className="PointsLeaderboardPage-loadMore">
        <Button 
          className="Button Button--primary"
          onclick={this.loadMore.bind(this)}
          loading={this.loadingMore}
          disabled={this.loadingMore || !this.hasMore}
        >
          {this.loadingMore 
            ? (app.translator.trans('tf-points.forum.leaderboard.loading') || 'Loading...')
            : (app.translator.trans('tf-points.forum.leaderboard.load_more') || 'Load More')}
        </Button>
      </div>
    );
  }

  loadMore() {
    if (this.loadingMore || !this.hasMore) return;
    
    this.currentPage += 1;
    this.loadingMore = true;
    
    if (this.activeTab === 'group') {
      this.loadGroupResults(true);
    } else {
      this.loadResults(true);
    }
  }

  loadResults(isLoadMore = false) {
    if (this.activeTab === 'group') {
      this.loadGroupResults(isLoadMore);
      return;
    }

    // personal（版主）和 users（普通用户）标签：使用 pointsboard 接口
    const limit = 20;
    const offset = isLoadMore ? this.boardList.length : 0;

    if (!isLoadMore) {
      this.loading = true;
      this.boardList = [];
      this.currentPage = 1;
    }

    // 根据标签确定 user_type 参数
    const userType = this.activeTab === 'personal' ? 'owner' : 'normal';
    return app.store
      .find("pointsboard", {
        page: {
          offset,
          limit
        },
        period: this.period,
        user_type: userType
      })
      .catch((error) => {
        console.error('Error loading points leaderboard:', error);
        this.loading = false;
        this.loadingMore = false;
        this.hasMore = false;
        if (!isLoadMore) {
          this.boardList = [];
        }
        m.redraw();
        return null;
      })
      .then((results) => {
        if (results) {
          this.parseResults(results, isLoadMore);
        }
      });
  }

  loadGroupResults(isLoadMore = false) {
    const limit = 20;
    const page = isLoadMore ? this.currentPage : 1;

    if (!isLoadMore) {
      this.loading = true;
      this.boardList = [];
      this.currentPage = 1;
    }

    return app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/social-groups/heat-rank`,
      params: {
        period: this.period === 'alltime' ? 'month' : this.period,
        page: {
          number: page,
          limit: limit
        }
      }
    }).then((response) => {
      this.parseGroupResults(response, isLoadMore);
    }).catch((error) => {
      console.error('Error loading group heat rank:', error);
      this.loading = false;
      this.loadingMore = false;
      if (!isLoadMore) {
        this.boardList = [];
      }
      m.redraw();
    });
  }

  parseGroupResults(response, isLoadMore = false) {
    try {
      let data = [];
      if (response.data && Array.isArray(response.data)) {
        data = response.data;
        this.hasMore = !!response.links && !!response.links.next;
      } else if (Array.isArray(response)) {
        data = response;
        this.hasMore = false;
      }

      if (Array.isArray(data) && data.length > 0) {
        if (isLoadMore) {
          this.boardList = this.boardList.concat(data);
        } else {
          this.boardList = data;
        }
      } else {
        if (!isLoadMore) {
          this.boardList = [];
        }
      }

      this.loading = false;
      this.loadingMore = false;
      m.redraw();
    } catch (error) {
      console.error('Error parsing group results:', error);
      this.loading = false;
      this.loadingMore = false;
      if (!isLoadMore) {
        this.boardList = [];
      }
      m.redraw();
    }
  }

  parseResults(results, isLoadMore = false) {
    try {
      let data = [];
      const limit = 20;
      
      if (results.data && Array.isArray(results.data)) {
        data = results.data;
        // 判断是否有更多数据：检查 links.next 或返回的数据是否等于 limit
        this.hasMore = !!(results.links && results.links.next) || data.length >= limit;
        this.meta = results.meta || {};
      } else if (Array.isArray(results)) {
        data = results;
        // 如果返回的是数组，根据长度判断是否有更多数据
        this.hasMore = data.length >= limit;
      } else {
        // 如果 results 不是预期的格式，尝试从其他属性获取数据
        if (results.payload && Array.isArray(results.payload.data)) {
          data = results.payload.data;
          this.hasMore = !!(results.payload.links && results.payload.links.next) || data.length >= limit;
          this.meta = results.payload.meta || {};
        } else {
          this.hasMore = false;
        }
      }

      if (Array.isArray(data) && data.length > 0) {
        // 保存数据快照，避免与侧边栏 Widget 共享 store 中的 User 模型。
        // Widget 默认加载 period=alltime，会覆盖 store 中同 ID 用户的 period_points，
        // 导致页面显示的数据被错误覆盖。
        const formattedData = data.map(item => {
          // 兼容 Flarum Model (item.data) 和原始 JSON (item.attributes)
          const attrs = item.data?.attributes || item.attributes || {};
          const id = item.data?.id ?? item.id;
          return {
            id,
            attributes: {
              displayName: attrs.displayName,
              username: attrs.username,
              avatarUrl: attrs.avatarUrl,
              cover_image: attrs.cover_image,
              period_points: attrs.period_points ?? attrs.points ?? 0,
              remote_points: attrs.remote_points ?? attrs.period_points ?? attrs.points ?? 0,
              points: attrs.points ?? 0
            }
          };
        });
        
        if (isLoadMore) {
          this.boardList = this.boardList.concat(formattedData);
          // 如果加载更多后返回的数据少于 limit，说明没有更多数据了
          if (formattedData.length < limit) {
            this.hasMore = false;
          }
        } else {
          this.boardList = formattedData;
        }
      } else {
        if (!isLoadMore) {
          this.boardList = [];
        }
        this.hasMore = false;
      }

      this.loading = false;
      this.loadingMore = false;
      m.redraw();
    } catch (error) {
      console.error('Error parsing results:', error);
      this.loading = false;
      this.loadingMore = false;
      this.hasMore = false;
      m.redraw();
    }
  }
}
